var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("j-flow", {
          ref: "flow",
          on: {
            "row-click": _vm.flowRowClick,
            pagination: _vm.hideFloatingPrompt
          }
        }),
        _vm._v(" "),
        _vm.flow
          ? _c("jFlowFloatingPrompt", {
              ref: "flowFloating",
              attrs: { flow: _vm.flow },
              on: {
                hideFloatingPrompt: _vm.hideFloatingPrompt,
                deleteFlow: _vm.deleteFlow
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-189374cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189374cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/flow-non-sla/jFlowIndex.vue
// module id = null
// module chunks = 